import 'intersection-observer';

import { cookieBar } from './cookie-bar/cookieBar';
import { accordion } from "./accordion/accordion";
import { form } from "./form/form";
import { collapsable } from "./collapsable/collapsable";
import { fancySelect } from "./fancy-select/fancySelect";
import { requestSteps } from "./request-steps/request-steps";

window.addEventListener('DOMContentLoaded', (): void => {

    cookieBar();
    accordion();
    form();
    collapsable();
    fancySelect();
    requestSteps();

});
